import {
  Apartment,
  AttachFileOutlined,
  HouseOutlined,
  PersonOutline,
} from "@mui/icons-material";
import { blue, green, lightGreen, purple } from "@mui/material/colors";
import { isArray, isObject } from "lodash";
import { addressLabel } from "../../../_src_shared/utils/functions/addressLabel";

export const ASSOCIATION_CONFIG = {
  loanDocuments: {
    key: "loanDocuments",
    label: "File",
    icon: <AttachFileOutlined className="thin" />,
    color: blue[800],
    background: blue[50],
    tooltip: "Select Existing File",
    enableSearch: true,
    getLoanData: (loan) => loan?.loanDocuments,
    getLabel: (item) => item?.file_display_name,
    getNavigationUrl: (loan, id) => null,
    usePreview: true,
  },
  borrowers: {
    key: "borrowers",
    label: "Borrower",
    icon: <PersonOutline className="thin" />,
    color: purple[800],
    background: purple[50],
    tooltip: "Tag/Assign Borrower",
    getLoanData: (loan) => loan?.borrowers,
    getLabel: (item) => `${item?.firstName || ""} ${item?.lastName || ""}`,
    // `base` is the ACTIVE pipeline's drilldown base ("/loan" or
    // "/acquisition") — see useDrilldownBase. It defaults to the preclose base
    // so callers outside a PipelineProvider keep working unchanged.
    getNavigationUrl: (loan, id, base = "/loan") =>
      `${base}/${loan?._id}/borrowers/${id}`,
  },
  subjectProperties: {
    key: "subjectProperties",
    label: "Property",
    icon: <HouseOutlined className="thin" />,
    color: green[800],
    background: green[50],
    tooltip: "Tag/Assign Property",
    getLoanData: (loan) => loan?.subjectProperties,
    getLabel: (item) => addressLabel(item?.address),
    getNavigationUrl: (loan, id, base = "/loan") =>
      `${base}/${loan?._id}/properties/${id}`,
  },
  // applications: {
  //   key: "applications",
  //   label: "Applications",
  //   icon: <DescriptionOutlined className="thin" />,
  //   color: orange[800],
  //   background: orange[50],
  //   tooltip: "Tag/Assign Loan Application",
  //   getLoanData: (loan) => loan?.applications,
  //   getLabel: (item) => item,
  //   getNavigationUrl: (loan, id) =>
  //     `/loan/${loan?._id}/properties/${id}`,
  // },
  // credit_authorizations: {
  //   key: "credit_authorizations",
  //   label: "Credit Authorizations",
  //   icon: <DescriptionOutlined className="thin" />,
  //   color: orange[800],
  //   background: orange[50],
  //   tooltip: "Tag/Assign Credit Authorization",
  //   getLoanData: (loan) => loan?.credit_authorizations,
  //   getLabel: (item) => "Credit Auth",
  //   getNavigationUrl: (loan, id) =>
  //     `/loan/${loan?._id}/properties/${id}`,
  // },
  borrowerEntity: {
    key: "borrowerEntity",
    label: "Entity",
    icon: <Apartment className="thin" />,
    color: lightGreen[900],
    background: lightGreen[100],
    tooltip: "Tag/Assign Entity",
    getLoanData: (loan) => {
      if (isArray(loan?.borrowerEntity)) return loan.borrowerEntity;
      if (isObject(loan?.borrowerEntity)) return [loan.borrowerEntity];
      return [];
    },
    getLabel: (item) => item?.entityName,
    getNavigationUrl: (loan, id, base = "/loan") =>
      `${base}/${loan?._id}/entity`,
  },
};
